import { render, staticRenderFns } from "./ZgbTeamMembersEdit.vue?vue&type=template&id=5ca70803"
import script from "./ZgbTeamMembersEdit.vue?vue&type=script&lang=js"
export * from "./ZgbTeamMembersEdit.vue?vue&type=script&lang=js"
import style0 from "./ZgbTeamMembersEdit.vue?vue&type=style&index=0&id=5ca70803&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports